import React from "react";

const PodCornerExpanded = ({
  viewBox = "0 0 130 375",
  className = "",
  color = "#7EA5BB"
}) => (
  <svg
    className={className}
    width="45%"
    height="85%"
    viewBox={viewBox}
    version="1.1"
  >
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.29"
    >
      <g
        id="Reporting-UI-Halfway-Version-(2)-(1)"
        transform="translate(-890.000000, -351.000000)"
        stroke={color}
      >
        <g id="hex" transform="translate(890.000000, 352.000000)">
          <g id="Group">
            <polygon
              id="Path"
              points="141.896216 112.27027 184.927568 136.131892 184.927568 181.944865 141.896216 205.404324 98.8648649 181.944865 98.8648649 136.131892"
            ></polygon>
            <path
              d="M89.9502703,62 L132.981622,85.8616216 L132.981622,131.674595 L89.9502703,155.134054 L46.9189189,131.674595 L46.9189189,85.8616216 L89.9502703,62 Z M120.715676,15.0810811 L140.270811,25.6378378 L140.270811,45.8967568 L120.715676,56.2859459 L101.143784,45.8967568 L101.143784,25.6210811 L120.715676,15.0810811 Z M64.8151351,0 L89.4140541,13.5562162 L89.4140541,39.5962162 L64.8151351,52.9178378 L40.2162162,39.5962162 L40.2162162,13.5562162 L64.8151351,0 Z"
              id="Shape"
            ></path>
            <path
              d="M39.68,45.2432432 L64.2789189,58.7994595 L64.2789189,84.8394595 L39.68,98.1610811 L15.0810811,84.8394595 L15.0810811,58.7994595 L39.68,45.2432432 Z M138.544865,56.972973 L163.143784,70.5291892 L163.143784,96.5691892 L138.544865,109.890811 L113.945946,96.5691892 L113.945946,70.5291892 L138.544865,56.972973 Z M14.7794595,6.7027027 L28.4864865,14.2432432 L28.4864865,28.7378378 L14.7794595,36.1610811 L1.07243243,28.7378378 L1.07243243,14.2432432 L14.7794595,6.7027027 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PodCornerExpanded;
